import { I18n } from 'aws-amplify/utils';

I18n.setLanguage('en');

export function getIntl<T extends Record<string, string>>(prefix: string, messages: T) {
    const withPrefixedKeys = Object.keys(messages).reduce((acc, key) => {
        acc[`${prefix}.${key}`] = messages[key];
        return acc;
    }, {} as Record<string, string>);
    I18n.putVocabularies({
        en: withPrefixedKeys,
    });
    return <K extends keyof T>(key: K, values?: Record<string, number | string | boolean>): string => {
        const rawIntlValue = I18n.get(`${prefix}.${String(key)}`);
        if (values) {
            return Object.keys(values).reduce((acc, key) => {
                return acc.split(`{${key}}`).join(String(values[key]));
            }, rawIntlValue);
        } else {
            return rawIntlValue;
        }
    };
}
